import { forwardRef } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import Message from "../../../../../../Chat/components/Message";
import DateDivider from "../../../../../../Chat/components/DateDivider";
import { useMessageGroups } from "../../../../../../Chat/hooks/useMessageGroups";
import { MessageSenderInfo, Message as MessageType } from "../../../../../../Chat/types/message";

const MessagesList = forwardRef<
  HTMLDivElement,
  {
    messages: MessageType[];
    currentUser: MessageSenderInfo;
    otherUser: MessageSenderInfo;
  }
>(({ messages, currentUser, otherUser }, ref) => {
  const { i18n } = useTranslation();
  const messageGroups = useMessageGroups(messages, i18n.language);

  return (
    <Box ref={ref} sx={styles.container}>
      {messageGroups.map(({ date, messages }) => (
        <Box key={date} sx={styles.group}>
          <DateDivider date={date} />
          <Box sx={styles.messages}>
            {messages.map((message) => (
              <Message key={message.uuid} message={message} currentUser={currentUser} otherUser={otherUser} />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
});

export default MessagesList;

const styles = {
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    overflowY: "auto",
    maxHeight: "1350px",
    paddingRight: "16px",
  },
  group: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  messages: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  message: {
    padding: "8px 12px",
    backgroundColor: "#f5f5f5",
    borderRadius: "8px",
  },
};
